export default __webpack_public_path__ + "static/aws-c4ce9b6d27e9cb88405341ad837e61ef.jpg";